<div class="modal fade section-gap-80" id="modal-historico-financeiro" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal"><i class="icon-xs-o-md"></i></button>
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <div class="form-group">

            <div class="container">
              <div class="row container" style="margin: auto;">
                <p>Na próxima tela, digite o usúario e senha e selecione o acesso conforme abaixo: </p>

                <div class="col-sm">

                  <div class="mt-1">
                    <div
                      class="bs-callout-danger callout-border-left callout-square callout-bordered callout-transparent mt-1 p-1">
                      <p>Usúario: <b>Seu CPF</b> </p>
                      <p>Senha: <b>Seu CPF</b></p>
                      <p>Acesso: <b></b>Beneficiário</p>
                    </div>

                  </div>
                </div>
                <div class="col-sm">
                  <img class="mt-1" style="width:70%"
                    src="../../../../assets/app-assets/images/ilustracao/fakplan-info.png">
                </div>

              </div>
              <div class="card-body col-sm">
                <div ><p class="badge badge-info"> Dica de segurança: Sugerimos que após
                  o 1º acesso, você altere sua senha</p></div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a>
            <button type="button" class="btn btn-info round" data-toggle="modal" (click)="redirectPage()" data-dismiss="modal">Ir para a área do cliente</button>            
          </a>
        </div>
      </div>
    </div>
  </div>
